// Symbol → Fun CDN logo map, duplicated verbatim from `@funkit/fun-relay`
// (`src/assets.ts`). We copy rather than import because `@funkit/fun-relay` has
// no subpath export — importing it would pull its relay-sdk / bitcoin adapter
// graph into the React Native bundle. This is a pure data map with no deps, so
// the cost of duplication is low; keep it in sync with fun-relay when symbols
// are added there.
//
// This is the primary symbol→logo source for the deposit token list. See
// `funIconUri.ts#tokenLogoUri` for how the transfer screen resolves icons
// (mirrors web's `getTokenIconUrl`, NOT the wallet-assets `getAssetLogoSrc`).
export const ASSET_LOGO_SRCS: Record<string, string> = {
  $MFER: 'https://sdk-cdn.fun.xyz/images/mfer.png',
  AARBUSDCN: 'https://sdk-cdn.fun.xyz/images/aarbusdcn.png',
  AAVE: 'https://sdk-cdn.fun.xyz/images/aave.svg',
  AERO: 'https://sdk-cdn.fun.xyz/images/aero.svg',
  APE: 'https://sdk-cdn.fun.xyz/images/ape.svg',
  APOLWMATIC: 'https://sdk-cdn.fun.xyz/images/apolwmatic.png',
  ARB: 'https://sdk-cdn.fun.xyz/images/arb.svg',
  BEHYPE: 'https://sdk-cdn.fun.xyz/images/behype.svg',
  BENTO: 'https://sdk-cdn.fun.xyz/images/bento.png',
  BLERF: 'https://sdk-cdn.fun.xyz/images/blerf.png',
  BRETT: 'https://sdk-cdn.fun.xyz/images/brett.svg',
  BSHIB: 'https://sdk-cdn.fun.xyz/images/bshib.png',
  BTC: 'https://sdk-cdn.fun.xyz/images/btc.svg',
  CBBTC: 'https://sdk-cdn.fun.xyz/images/cbbtc.svg',
  CBETH: 'https://sdk-cdn.fun.xyz/images/cbeth.png',
  CRO: 'https://sdk-cdn.fun.xyz/images/cro.svg',
  CRV: 'https://sdk-cdn.fun.xyz/images/crv.svg',
  DAI: 'https://sdk-cdn.fun.xyz/images/dai.svg',
  DEGEN: 'https://sdk-cdn.fun.xyz/images/degen.svg',
  ETH: 'https://sdk-cdn.fun.xyz/images/eth.svg',
  GMX: 'https://sdk-cdn.fun.xyz/images/gmx.svg',
  GRT: 'https://sdk-cdn.fun.xyz/images/grt.svg',
  HYPE: 'https://sdk-cdn.fun.xyz/images/hype.svg',
  IMX: 'https://sdk-cdn.fun.xyz/images/imx.svg',
  INJ: 'https://sdk-cdn.fun.xyz/images/inj.svg',
  LDO: 'https://sdk-cdn.fun.xyz/images/ldo.svg',
  LINK: 'https://sdk-cdn.fun.xyz/images/link.png',
  LUCK: 'https://sdk-cdn.fun.xyz/images/luck.png',
  MATIC: 'https://sdk-cdn.fun.xyz/images/matic.svg',
  MFER: 'https://sdk-cdn.fun.xyz/images/mfer.png',
  MKR: 'https://sdk-cdn.fun.xyz/images/mkr.svg',
  MNT: 'https://sdk-cdn.fun.xyz/images/mnt.svg',
  OP: 'https://sdk-cdn.fun.xyz/images/optimism.svg',
  PENDLE: 'https://sdk-cdn.fun.xyz/images/pendle.svg',
  POL: 'https://sdk-cdn.fun.xyz/images/matic.svg',
  PYUSD: 'https://sdk-cdn.fun.xyz/images/pyusd.svg',
  QNT: 'https://sdk-cdn.fun.xyz/images/qnt.svg',
  RNDR: 'https://sdk-cdn.fun.xyz/images/rndr.svg',
  ROOST: 'https://sdk-cdn.fun.xyz/images/roost.png',
  SAND: 'https://sdk-cdn.fun.xyz/images/sand.svg',
  SHIB: 'https://sdk-cdn.fun.xyz/images/shib.svg',
  SNX: 'https://sdk-cdn.fun.xyz/images/snx.svg',
  SOL: 'https://sdk-cdn.fun.xyz/images/sol.svg',
  SUSDS: 'https://sdk-cdn.fun.xyz/images/susds.svg',
  TYBG: 'https://sdk-cdn.fun.xyz/images/tybg.png',
  UNI: 'https://sdk-cdn.fun.xyz/images/uni.png',
  USDC: 'https://sdk-cdn.fun.xyz/images/usdc.svg',
  'USDC.E': 'https://sdk-cdn.fun.xyz/images/usdc.svg',
  USDBC: 'https://sdk-cdn.fun.xyz/images/usdc.svg',
  USDE: 'https://sdk-cdn.fun.xyz/images/usde.svg',
  WUSDE: 'https://sdk-cdn.fun.xyz/images/usde.svg',
  EUSDE: 'https://sdk-cdn.fun.xyz/images/eusde.svg',
  USDT: 'https://sdk-cdn.fun.xyz/images/usdt.svg',
  'USD₮0': 'https://sdk-cdn.fun.xyz/images/usdt0.svg',
  USDT0: 'https://sdk-cdn.fun.xyz/images/usdt0.svg',
  USDS: 'https://sdk-cdn.fun.xyz/images/usds.svg',
  USDH: 'https://sdk-cdn.fun.xyz/images/usdh.svg',
  VRTX: 'https://sdk-cdn.fun.xyz/images/vrtx.svg',
  WBTC: 'https://sdk-cdn.fun.xyz/images/wbtc.svg',
  WEETH: 'https://sdk-cdn.fun.xyz/images/weeth.png',
  WETH: 'https://sdk-cdn.fun.xyz/images/weth.svg',
  WHYPE: 'https://sdk-cdn.fun.xyz/images/whype.png',
  WSTETH: 'https://sdk-cdn.fun.xyz/images/wsteth.png',
  TRUMP: 'https://sdk-cdn.fun.xyz/images/trump.png',
  BNB: 'https://sdk-cdn.fun.xyz/images/bsc.svg',
  WBNB: 'https://sdk-cdn.fun.xyz/images/bsc.svg',
  BTCB: 'https://sdk-cdn.fun.xyz/images/btc.svg',
  UBTC: 'https://sdk-cdn.fun.xyz/images/btc.svg',
  BUSD: 'https://sdk-cdn.fun.xyz/images/busd.svg',
  XAUT: 'https://sdk-cdn.fun.xyz/images/xaut.png',
  ADA: 'https://sdk-cdn.fun.xyz/images/ada.svg',
  XRP: 'https://sdk-cdn.fun.xyz/images/xrp.svg',
  UDOGE: 'https://sdk-cdn.fun.xyz/images/doge.svg',
  DOGE: 'https://sdk-cdn.fun.xyz/images/doge.svg',
  LTC: 'https://sdk-cdn.fun.xyz/images/ltc.svg',
  HNT: 'https://sdk-cdn.fun.xyz/images/hnt.svg',
  COMP: 'https://sdk-cdn.fun.xyz/images/comp.svg',
  PEPE: 'https://sdk-cdn.fun.xyz/images/pepe.svg',
  LSTHYPE: 'https://sdk-cdn.fun.xyz/images/lsthype.svg',
  HBUSDT: 'https://sdk-cdn.fun.xyz/images/hbusdt.svg',
  WVLP: 'https://sdk-cdn.fun.xyz/images/wvlp.svg',
  LIQUIDHYPE: 'https://sdk-cdn.fun.xyz/images/liquidhype.svg',
  VHYPE: 'https://sdk-cdn.fun.xyz/images/vhype.png',
  HBHYPE: 'https://sdk-cdn.fun.xyz/images/hbhype.svg',
  MON: 'https://sdk-cdn.fun.xyz/images/monad.svg',
  WMON: 'https://sdk-cdn.fun.xyz/images/wmon.svg',
  AUSD: 'https://sdk-cdn.fun.xyz/images/ausd.svg',
  SUSHI: 'https://sdk-cdn.fun.xyz/images/sushi.svg',
  SKY: 'https://sdk-cdn.fun.xyz/images/sky.svg',
  LIT: 'https://sdk-cdn.fun.xyz/images/lit.svg',
  AZTEC: 'https://sdk-cdn.fun.xyz/images/aztec.svg',
  U: 'https://sdk-cdn.fun.xyz/images/u.png',
  PUSD: 'https://sdk-cdn.fun.xyz/images/pusd.svg',
}

/** Generic fallback logo when a symbol isn't in the map. */
export const FALLBACK_ASSET_LOGO =
  'https://sdk-cdn.fun.xyz/images/dollar_circle.png'

/**
 * Verbatim mirror of `@funkit/fun-relay`'s `getAssetLogoSrc`: resolve a token's
 * logo URL by symbol (case-insensitive), falling back to a generic dollar-circle.
 * This is web's *wallet-assets* resolver. NOTE: the deposit/transfer token list
 * does NOT use this — it uses {@link tokenLogoUri} (web's `getTokenIconUrl`),
 * which falls back to `<symbol>.svg` rather than the dollar-circle.
 */
export function getAssetLogoSrc(symbol: string): string {
  return ASSET_LOGO_SRCS[symbol.toUpperCase()] ?? FALLBACK_ASSET_LOGO
}
